// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"DownloadRiselio_Wrapper__GvvkO","Screenshoot__image":"DownloadRiselio_Screenshoot__image__2t58x"};